export const ru = {
    number: '№ {id}'
};
